module.exports = __webpack_public_path__ + "static/icons/icon-chevron-circle-left--white-eb6f8f9192bfbccf9a3fb0893aca6a92.svg";